import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./DailyTournaments.css";

const API = process.env.REACT_APP_API;

const DailyTournaments = () => {
  const { user } = useAuth(); 
  const navigate = useNavigate();  
  
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournament, setSelectedTournament] = useState(null);
  
  // שליפת רשימה מהשרת
  useEffect(() => {
    fetch(`${API}/api/dailyTournaments`)
      .then((res) => res.json())
      .then((data) => setTournaments(data))
      .catch((err) => console.error("שגיאה בשליפת רשימת הטורנירים היומיים:", err));
  }, []);

  const loadTournamentDetails = async (id) => {
  try {
    const res = await axios.get(`${API}/api/dailyTournaments/${id}`);
    setSelectedTournament(res.data);
  } catch (err) {
      console.error("שגיאה בשליפת פרטי הטורניר:", err);
  }
};

  return (
    <div className="daily-tournaments">
      {/* אייקון הבית בפינה שמאלית עליונה */}
        <div className="home-icon">
          <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
        </div>
        <div className="back-icon">
          <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
      </div>
      {/* צד ימין – רשימת טורנירים */}
      <aside className="tournament-list">
        <h3>טורנירים יומיים</h3>
        {user?.isAdmin && (
        <Link to="/dailyTournaments/new" className="btn add-btn">
          ➕ הוספת טורניר
        </Link>
        )}
        <ul>
          {tournaments.length === 0 ? (
          <p className="no-tournaments">אין טורנירים להצגה</p>
          ) : (
          tournaments
            .filter(t => user?.isAdmin || t.showOnSite) // 👈 רק אדמין רואה הכל, משתמש רגיל רואה רק כאלה שמסומנים להצגה
            .sort((a, b) => new Date(b.date) - new Date(a.date)) // מסדר לפי תאריך מהמאוחר לחדש
            .map((tournament) => (
              <li
                key={tournament._id}
                className={`tournament-item ${selectedTournament?._id === tournament._id ? "selected" : ""}`}
                onClick={() => loadTournamentDetails(tournament._id)}>
                  <strong>
                    {tournament.name} -{" "}
                    {new Date(tournament.date).toLocaleDateString(("HE-IL"))}
                  </strong>
              </li>
            ))
          )}
        </ul>
      </aside>

       {/* צד שמאל – פרטים */}
      <main className="tournament-details">
      {tournaments.length !== 0 ?
        (selectedTournament ? (
        <>
          <h3>
            {selectedTournament.name} - {" "}
            {new Date(selectedTournament.date).toLocaleDateString(("HE-IL"))}
          </h3>

          {selectedTournament.showFlyer && selectedTournament.flyer && (
            <img src={selectedTournament.flyer}
              alt={selectedTournament.name}
              className="flyer"
            />
          )}

          <div className="tournament-actions">
            {selectedTournament.showRegistration && (
              <a href={
                selectedTournament.registrationLink && 
                selectedTournament.registrationLink.trim() !==""
                  ? selectedTournament.registrationLink
                  : "https://example.com/default-registration"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="btn"
              >
                הרשמה
              </a>
            )}

            {selectedTournament.showFacebook && (
              <a href={
                selectedTournament.facebookLink &&
                selectedTournament.facebookLink.trim() !==""
                  ? selectedTournament.facebookLink
                  : "https://facebook.com/default-page"
                }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
              >
                פייסבוק
              </a>
            )}
          </div>
            
            {selectedTournament.showGallery && (
              <div className="gallery">
                {(Array.isArray(selectedTournament.gallery) ? selectedTournament.gallery : [])
                .map((img, idx) => (
                  <img key={idx}
                    src={img}
                    alt="תמונה" />
                ))}
              </div>
            )}

            <br />
          {user?.isAdmin && (  
          <>
          <p className="status">
            סטטוס:{""}
            {selectedTournament.showOnSite
            ? "✅ מוצג למבקרים"
            : "❌ מוסתר ממבקרים"}
          </p>
          
            <button
              onClick={()=> navigate(`/dailyTournaments/edit/${selectedTournament._id}`)}
              className="btn edit-btn"
            >
              ✏️ עריכה
            </button>
          </>
          )}
        </>
        ) : (
            <p>בחרי טורניר להצגת פרטים</p>
            )
        ) : <p className="no-tournaments">אין טורנירים להצגה</p>
      }
        <br />
      </main>
    </div>
  );
}

export default DailyTournaments;
